import { lazy } from "react";

import AuthGuard from "../utils/route-guard/AuthGuard";
import MainLayout from "../layout/MainLayout";
import Loadable from "../ui-component/Loadable";
import Folders from "@src/views/application/exercises/Folders";
import Folder from "@src/views/application/exercises/Folder";

const Admins = Loadable(
  lazy(() => import("../views/application/admins/list/Style1"))
);
const AddAdmin = Loadable(
  lazy(() => import("../views/application/admins/create"))
);
const EditAdmin = Loadable(
  lazy(() => import("../views/application/admins/edit"))
);

const Equipments = Loadable(
  lazy(() => import("../views/application/equipments/list/Style1"))
);
const AddEquipment = Loadable(
  lazy(() => import("../views/application/equipments/create"))
);
const EditEquipment = Loadable(
  lazy(() => import("../views/application/equipments/edit"))
);

const EquipmentType = Loadable(
  lazy(() => import("../views/application/equipmentType/list/Style1"))
);
const AddEquipmentType = Loadable(
  lazy(() => import("../views/application/equipmentType/create"))
);
const EditEquipmentType = Loadable(
  lazy(() => import("../views/application/equipmentType/edit"))
);

const Bodyparts = Loadable(
  lazy(() => import("../views/application/bodyparts/list/Style1"))
);
const AddBodyparts = Loadable(
  lazy(() => import("../views/application/bodyparts/create"))
);
const EditBodyparts = Loadable(
  lazy(() => import("../views/application/bodyparts/edit"))
);

const Exercise = Loadable(
  lazy(() => import("../views/application/exercises/list/Style1"))
);
const AddExercise = Loadable(
  lazy(() => import("../views/application/exercises/create"))
);
const EditExercise = Loadable(
  lazy(() => import("../views/application/exercises/edit"))
);

const Users = Loadable(
  lazy(() => import("../views/application/users/list/Style1"))
);
const AddUser = Loadable(
  lazy(() => import("../views/application/users/create"))
);
const EditUser = Loadable(
  lazy(() => import("../views/application/users/edit"))
);

const Workout = Loadable(
  lazy(() => import("../views/application/workout/list/Style1"))
);
const AddWorkout = Loadable(
  lazy(() => import("../views/application/workout/create"))
);
const EditWorkout = Loadable(
  lazy(() => import("../views/application/workout/edit"))
);

const Nutrition = Loadable(
  lazy(() => import("../views/application/nutrition/list/Style1"))
);
const AddNutrition = Loadable(
  lazy(() => import("../views/application/nutrition/create"))
);
const EditNutrition = Loadable(
  lazy(() => import("../views/application/nutrition/edit"))
);

const Location = Loadable(
  lazy(() => import("../views/application/location/list/Style1"))
);
const AddLocation = Loadable(
  lazy(() => import("../views/application/location/create"))
);
const EditLocation = Loadable(
  lazy(() => import("../views/application/location/edit"))
);

const QRCodes = Loadable(
  lazy(() => import("../views/application/qrcode/list/Style1"))
);
const AddQRCode = Loadable(
  lazy(() => import("../views/application/qrcode/create"))
);
const EditQRCode = Loadable(
  lazy(() => import("../views/application/qrcode/edit"))
);

const Collections = Loadable(
  lazy(() => import("../views/application/collections/list/Style1"))
);
const AddCollection = Loadable(
  lazy(() => import("../views/application/collections/create"))
);
const EditCollection = Loadable(
  lazy(() => import("../views/application/collections/edit"))
);

const ExerciseTags = Loadable(
  lazy(() => import("../views/application/exercisetags/list/Style1"))
);
const AddExerciseTag = Loadable(
  lazy(() => import("../views/application/exercisetags/create"))
);
const EditExerciseTag = Loadable(
  lazy(() => import("../views/application/exercisetags/edit"))
);

const WorkoutTags = Loadable(
  lazy(() => import("../views/application/workouttags/list/Style1"))
);
const AddWorkoutTags = Loadable(
  lazy(() => import("../views/application/workouttags/create"))
);
const EditWorkoutTags = Loadable(
  lazy(() => import("../views/application/workouttags/edit"))
);

const Gyms = Loadable(
  lazy(() => import("../views/application/gyms/list/Style1"))
);
const AddGym = Loadable(lazy(() => import("../views/application/gyms/create")));
const EditGym = Loadable(lazy(() => import("../views/application/gyms/edit")));

const Specialist = Loadable(
  lazy(() => import("../views/application/specialists/list/Style1"))
);
const AddSpecialist = Loadable(
  lazy(() => import("../views/application/specialists/create"))
);
const EditSpecialist = Loadable(
  lazy(() => import("../views/application/specialists/edit"))
);

const ChangePassword = Loadable(
  lazy(() => import("../views/application/settings/ChangePassword"))
);
const Caching = Loadable(lazy(() => import("../views/application/caching")));
const Performance = Loadable(
  lazy(() => import("../views/application/performance"))
);
const Scores = Loadable(lazy(() => import("../views/application/scores")));
const AiConfig = Loadable(lazy(() => import("../views/application/aiconfig")));
const CoachyErrors = Loadable(
  lazy(() => import("../views/application/coachyerrors"))
);
const Labels = Loadable(lazy(() => import("../views/application/labels")));
const Covers = Loadable(lazy(() => import("../views/application/covers")));

const MainRoutes = {
  path: "",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "",
      element: <Admins />,
    },
    {
      path: "/admins",
      element: <Admins />,
    },
    {
      path: "/add-admin",
      element: <AddAdmin />,
    },
    {
      path: "/edit-admin/:id",
      element: <EditAdmin />,
    },
    {
      path: "/users",
      element: <Users />,
    },
    {
      path: "/add-user",
      element: <AddUser />,
    },
    {
      path: "/edit-user/:id",
      element: <EditUser />,
    },
    {
      path: "/gyms",
      element: <Gyms />,
    },
    {
      path: "/add-gym",
      element: <AddGym />,
    },
    {
      path: "/edit-gym/:id",
      element: <EditGym />,
    },
    {
      path: "/specialists",
      element: <Specialist />,
    },
    {
      path: "/add-specialists",
      element: <AddSpecialist />,
    },
    {
      path: "/edit-specialists/:id",
      element: <EditSpecialist />,
    },
    {
      path: "/equipments",
      element: <Equipments />,
    },
    {
      path: "/add-equipment",
      element: <AddEquipment />,
    },
    {
      path: "/edit-equipment/:id",
      element: <EditEquipment />,
    },
    {
      path: "/equipment-type",
      element: <EquipmentType />,
    },
    {
      path: "/add-equipment-type",
      element: <AddEquipmentType />,
    },
    {
      path: "/edit-equipment-type/:id",
      element: <EditEquipmentType />,
    },

    {
      path: "/bodyparts",
      element: <Bodyparts />,
    },
    {
      path: "/add-bodyparts",
      element: <AddBodyparts />,
    },
    {
      path: "/edit-bodyparts/:id",
      element: <EditBodyparts />,
    },
    {
      path: "/exercise",
      element: <Exercise />,
    },
    {
      path: "/exercise/folders",
      element: <Folders />,
    },
    {
      path: "/exercise/folders/:id",
      element: <Folder />,
    },
    {
      path: "/add-exercise",
      element: <AddExercise />,
    },
    {
      path: "/edit-exercise/:id",
      element: <EditExercise />,
    },
    {
      path: "/exercise-tags",
      element: <ExerciseTags />,
    },
    {
      path: "/add-exercise-tag",
      element: <AddExerciseTag />,
    },
    {
      path: "/edit-exercise-tags/:id",
      element: <EditExerciseTag />,
    },
    {
      path: "/workout",
      element: <Workout />,
    },
    {
      path: "/nutrition",
      element: <Nutrition />,
    },
    {
      path: "/add-workout",
      element: <AddWorkout />,
    },
    {
      path: "/add-nutrition",
      element: <AddNutrition />,
    },
    {
      path: "/edit-nutrition",
      element: <AddNutrition />,
    },
    {
      path: "/edit-workout/:id",
      element: <EditWorkout />,
    },
    {
      path: "/edit-nutrition/:id",
      element: <EditNutrition />,
    },
    {
      path: "/workout-tags",
      element: <WorkoutTags />,
    },
    {
      path: "/add-workout-tag",
      element: <AddWorkoutTags />,
    },
    {
      path: "/edit-workout-tags/:id",
      element: <EditWorkoutTags />,
    },
    {
      path: "/collections",
      element: <Collections />,
    },
    {
      path: "/add-collection",
      element: <AddCollection />,
    },
    {
      path: "/edit-collection/:id",
      element: <EditCollection />,
    },
    {
      path: "/locations",
      element: <Location />,
    },
    {
      path: "/add-location",
      element: <AddLocation />,
    },
    {
      path: "/edit-location/:id",
      element: <EditLocation />,
    },
    {
      path: "/exercise-tags",
      element: <Location />,
    },
    {
      path: "/add-location",
      element: <AddLocation />,
    },
    {
      path: "/edit-location/:id",
      element: <EditLocation />,
    },
    {
      path: "/qrcodes",
      element: <QRCodes />,
    },
    {
      path: "/add-location",
      element: <AddQRCode />,
    },
    {
      path: "/edit-location/:id",
      element: <EditQRCode />,
    },

    {
      path: "/change-password",
      element: <ChangePassword />,
    },
    {
      path: "/caching",
      element: <Caching />,
    },
    {
      path: "/performance",
      element: <Performance />,
    },
    {
      path: "/scores",
      element: <Scores />,
    },
    {
      path: "/ai-config",
      element: <AiConfig />,
    },
    {
      path: "/coachy-errors",
      element: <CoachyErrors />,
    },
    {
      path: "/labels",
      element: <Labels />,
    },
    {
      path: "/covers",
      element: <Covers />,
    },
  ],
};

export default MainRoutes;
